export default "__VITE_ASSET__f0b4fa4c__"